import {
  type FabricToolbarResetNavbarApi,
  resetNavbar,
} from './reset-navbar.js';
import { type FabricToolbarSetNavbarApi, setNavbar } from './set-navbar.js';
import {
  type FabricToolbarSetPageTitleApi,
  setPageTitle,
} from './set-page-title.js';
import {
  type FabricToolbarUpdateNavbarApi,
  updateNavbar,
} from './update-navbar.js';

export type FabricToolbarApi = {
  /**
   * 设置navbar. 如果开启float模式则需要在H5 url上增加 `ntv_float`参数
   * 注意数据内容的配置与UI上`left`,`center`,`right`保持一致.
   */
  setNavbar: FabricToolbarSetNavbarApi;

  /**
   * 更新navbar. 在极端情况下, 我们可能需要多次更新navbar, 这个时候我们不想每次全量传输数据, 比如有图片base64有性能问题.
   * 这个时候我们需要调用updateNavbar()进行第一级别的差异更新.
   * `opacity`, `bgColor`, `statusBarStyle`,`left`,`center`,`right`
   */
  updateNavbar: FabricToolbarUpdateNavbarApi;
  /**
   * 重置标题栏, 如果当前是float模式, 仍然保持, 只是重置调toolbar设置的按钮相关功能.
   */
  resetNavbar: FabricToolbarResetNavbarApi;
  /**
   * 设置自定义标题
   */
  setPageTitle: FabricToolbarSetPageTitleApi;
};

export const fabricToolbar: FabricToolbarApi = {
  setNavbar,
  updateNavbar,
  resetNavbar,
  setPageTitle,
};
